import { Smartphone, FileText, CreditCard, X } from "lucide-react"; 


const ModalPayments = ({ price, discountPrice, selectedPayment, setSelectedPayment, setPaymentModalOpen }) => {
  const paymentMethods = [
    {
      id: "pix",
      name: "PIX",
      description: "Pagamento instantâneo via PIX",
      icon: Smartphone,
      discount: "5% de desconto",
      color: "bg-green-300",
      iconColor: "text-black",
    },
    {
      id: "boleto",
      name: "Boleto Bancário",
      description: "Vencimento em 3 dias úteis",
      icon: FileText,
      discount: "3% de desconto",
      color: "bg-green-300",
      iconColor: "text-black",
    },
    {
      id: "cartao",
      name: "Cartão de Crédito",
      description: "Parcelamento em até 12x sem juros",
      icon: CreditCard,
      discount: "Sem desconto",
      color: "bg-green-300",
      iconColor: "text-black",
    },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-gray-900">Formas de Pagamento</h2>
            <button
            onClick={() => setPaymentModalOpen(false)}
            className="rounded-md px-1 py-0.5 text-sm font-medium text-white bg-red-500 hover:bg-red-600"
          >
            <X className="w-6 h-6" />
          </button>
          </div>

          <div className="grid gap-4 py-4">
            {paymentMethods.map((method) => {
              const IconComponent = method.icon;
              return (
                <div
                  key={method.id}
                  className={`border rounded-lg  transition-all shadow-md }`}
                  onClick={() => setSelectedPayment(method.id)}
                >
                  <div className="p-4">
                    <div className="flex items-center gap-4">
                      <div className={`p-3 rounded-full ${method.color}`}>
                        <IconComponent className={`w-6 h-6 ${method.iconColor}`} />
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between mb-1">
                          <h3 className="font-semibold text-lg">{method.name}</h3>
                          <span
                            className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${
                              method.discount === "Sem desconto"
                                ? "bg-gray-200 text-black"
                                : "bg-gray-200 text-black"
                            }`}
                          >
                            {method.discount}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600">{method.description}</p>

                        {method.id === "pix" && discountPrice && (
                          <div className="mt-2 text-sm">
                            <span className="font-semibold text-green-600">
                              R$ {(discountPrice * 0.95).toFixed(2)}
                            </span>
                            <span className="text-black  ml-2">à vista</span>
                          </div>
                        )}

                        {method.id === "boleto" && discountPrice && (
                          <div className="mt-2 text-sm">
                            <span className="font-semibold text-green-600">
                              R$ {(discountPrice * 0.97).toFixed(2)}
                            </span>
                            <span className="text-black ml-2">à vista</span>
                          </div>
                        )}

                        {method.id === "cartao" && (
                          <div className="mt-2 space-y-1 text-sm">
                            <div>
                              <span className=" font-semibold text-green-600">
                                R$ {discountPrice ? discountPrice.toFixed(2) : price.toFixed(2)}
                              </span>   
                              <span className="text-black ml-2">à vista</span>
                             
                            </div>
                            <div>
                              <span className="font-semibold">Parcelado:</span>
                              <span className="ml-2">12x de R$ {(price / 12).toFixed(2)}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPayments;
